exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * @Author: Zewei\n * @Date:   2018-01-29T10:23:08+08:00\n * @Last modified by:   Zewei\n * @Last modified time: 2018-01-30T11:07:05+08:00\n */\n.buttonGap {\n  margin-right: 4px;\n}\n.position-form-item > div {\n  margin-bottom: 24px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/routes/DepartmentStructure/style.less
// module id = 1635
// module chunks = 0